module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-22-7aff95194944be1f7063f0cbb96a1875.svg";